import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

const SmallText = css`
  font-size: 24px;
  font-weight: bold;
`;

const TimePart = css`
  display: inline-flex;
  align-items: baseline;
`;

const LargeText = css`
  font-size: 46px;
  font-weight: bold;

  span {
    font-size: 16px;
    margin-left: 4px;
  }
`;

export const TimeDisplay = React.memo(({ minutes }: { minutes?: number | null }) => {
  const { t, i18n } = useTranslation();
  const isJa = i18n.language.startsWith('ja');
  if (!minutes) {
    return <div css={LargeText}>-</div>;
  }

  const days = Math.floor(minutes / (60 * 24));
  const hours = Math.floor((minutes % (60 * 24)) / 60);
  const rem = Math.floor(minutes % 60);

  return (
    <>
      <span>{t('average', '平均')}</span>
      {days > 0 && (
        <span css={TimePart}>
          <span css={LargeText}>{days}</span>
          <span css={SmallText}>{isJa ? t('days', '日') : t('d', '日')}</span>
        </span>
      )}
      {hours > 0 && (
        <span css={TimePart}>
          <span css={LargeText}>{hours}</span>
          <span css={SmallText}>{isJa ? t('hours', '時間') : t('Hr', '時間')}</span>
        </span>
      )}
      {days === 0 && rem > 0 && (
        <span css={TimePart}>
          <span css={LargeText}>{rem}</span>
          <span css={SmallText}>{isJa ? t('minutes', '分') : t('Min', '分')}</span>
        </span>
      )}
    </>
  );
});
